import { render, staticRenderFns } from "./FieldHistoryButton.vue?vue&type=template&id=8ce94612&scoped=true"
import script from "./FieldHistoryButton.vue?vue&type=script&lang=js"
export * from "./FieldHistoryButton.vue?vue&type=script&lang=js"
import style0 from "./FieldHistoryButton.vue?vue&type=style&index=0&id=8ce94612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce94612",
  null
  
)

export default component.exports